import { GlobalService } from 'src/app/global.service';
import { Component, OnInit } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { ThemePalette, ProgressSpinnerMode, MatDialog } from '@angular/material';

@Component({
  selector: 'app-monthly-supplied-milk-for-card-customer',
  templateUrl: './monthly-supplied-milk-for-card-customer.component.html',
  styleUrls: ['./monthly-supplied-milk-for-card-customer.component.scss']
})
export class MonthlySuppliedMilkForCardCustomerComponent implements OnInit {

  is_document_available: boolean = true;
  is_data_available: boolean = true;
  total_sale_details: any;
  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'indeterminate';
  title: any;
  document_file: any = null;


  monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  selected_month: any;
  month_list_for_last_12_months: Array<any> = [];
  from_period_list: Array<any> = [];
  to_period_list: Array<any> = [];
  from_period: any = null;
  to_period: any = null;
  selected_customer_types_id: number[] = []; // Ensure this is initialized as an empty array

  constructor(private httpService: HttpService, private dialog: MatDialog, private global: GlobalService) {
    this.title = this.global._active_display_name;

    let today = new Date();
    today.setDate(1);
    let data_dict = {
      'month_in_string': this.monthNames[today.getMonth()],
      'month_in_integer': today.getMonth(),
      'year': today.getFullYear()
    }
    this.month_list_for_last_12_months.push(data_dict);
    for (let i = 0; i <= 11; i++) {
      today.setMonth(today.getMonth() - 1);
      let data_dict = {
        'month_in_string': this.monthNames[today.getMonth()],
        'month_in_integer': today.getMonth(),
        'year': today.getFullYear()
      };
      this.month_list_for_last_12_months.push(data_dict);
    }
    console.log(this.month_list_for_last_12_months);
  }

  getClicked() {
    if (this.from_period && this.to_period) {
      let data_dict = {
        'from_month': this.from_period.month + 1, // Months in JavaScript are zero-indexed
        'from_year': this.from_period.year,
        'to_month': this.to_period.month + 1, // Months in JavaScript are zero-indexed
        'to_year': this.to_period.year,
      };
      this.is_document_available = false;
      this.document_file = null;
      this.httpService.serveMilkSupplyFroCardCustomer(data_dict).subscribe((data) => {
        console.log(data);
        this.document_file = data;
        this.is_document_available = true;
      }, (error) => {
        this.is_document_available = true;
      });
    }
  }

  downloadClicked() {
    const linkSource = 'data:application/pdf;base64,' + this.document_file['pdf'];
    const downloadLink = document.createElement("a");
    const fileName = this.document_file['file_name'];
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  }

  ngOnInit() {
    this.generateMonthList();
    this.from_period_list = [...this.month_list_for_last_12_months];
  }

  generateMonthList() {
    const startYear = 2019;
    const currentDate = new Date();
    const currentMonth = currentDate.getMonth(); // Month is zero-indexed (0 for January, 11 for December)
    const currentYear = currentDate.getFullYear();

    for (let year = startYear; year <= currentYear; year++) {
      const endMonth = (year === currentYear) ? currentMonth : 11; // December is 11th month
      for (let month = 0; month <= endMonth; month++) {
        const monthString = new Date(year, month).toLocaleString('default', { month: 'long' });
        this.month_list_for_last_12_months.push({ month_in_string: monthString, month: month, year: year });
      }
    }

    // Sort the list to ensure correct chronological order
    this.month_list_for_last_12_months.sort((a, b) => {
      if (a.year !== b.year) {
        return a.year - b.year; // Sort by year first
      }
      return a.month - b.month; // Then sort by month within the same year
    });
  }

  updateToPeriodOptions() {
    if (this.from_period) {
      const fromIndex = this.month_list_for_last_12_months.findIndex(period =>
        period.year === this.from_period.year && period.month === this.from_period.month
      );
      this.to_period_list = this.month_list_for_last_12_months.slice(fromIndex);
    } else {
      this.to_period_list = [...this.month_list_for_last_12_months];
    }
  }
}
